/**
 * Classic R, intermission 2: butterflies in a row under a shelf of boulders (docs/spec/03 §2).
 * Each butterfly circles one cell of dirt; run the seam above them and the shelf comes down.
 */

import type { CaveDef } from '../types';

export const caveR: CaveDef = {
  id: 'R',
  name: 'MOTH PARADE',
  hint: 'Four butterflies, twelve boulders, one run.',
  intermission: true,
  colors: [6, 13, 7],
  diamondValue: 30,
  extraValue: 45,
  fill: { base: '.', items: [['r', 15], ['d', 12]] },
  levels: [
    { seed: 2101, diamonds: 14, time: 30, tick: 150 },
    { seed: 2102, diamonds: 16, time: 28, tick: 140 },
    { seed: 2103, diamonds: 18, time: 26, tick: 130 },
    { seed: 2104, diamonds: 20, time: 24, tick: 120 },
    { seed: 2105, diamonds: 22, time: 22, tick: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'WP.r.?.r.d.r.?.r.d.W',
    'W..r...r.?.r.d.r.??W',
    'W..r.d.r...r...r...W',
    'W..................W',
    'W.. ... ... ... ...W',
    'W..   .   .   .   .W',
    'W.. .b. .b. .b. .bdW',
    'W..   .   .   .   .W',
    'W.d.......d........W',
    'W?????????????????XW',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
